import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { useIntl } from "react-intl";
import { LoadingPane } from "@folio/stripes/components";
import { fetchLegalPersonById } from "../../api/legalPersonService";
import { LegalPersonStatusEnum } from "../../types/Api";
import { useGetCurrentUser } from "../../utils/useCurrentUser";
import { usePermissions } from "../../hooks/usePermissions";
import LegalPersonForm from "./LegalPersonForm";
var LegalPersonEdit = function () {
    var _a, _b;
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var id = useParams().id;
    var _c = useGetCurrentUser(), currentUser = _c.data, isCurrentUserLoading = _c.isLoading;
    var isSuperUser = usePermissions().isSuperUser;
    var _d = useQuery(["legal-person", id], function () { return fetchLegalPersonById(ky, id); }, {
        enabled: !!id,
    }), legalPerson = _d.data, isLoading = _d.isLoading, error = _d.error;
    if (isLoading || isCurrentUserLoading) {
        return React.createElement(LoadingPane, null);
    }
    if (error || !legalPerson) {
        return (React.createElement("div", null,
            formatMessage({ id: "ui-br-agency.modal.label.error" }),
            ":",
            " ",
            formatMessage({ id: "ui-br-agency.legal-person.not.found" })));
    }
    if (legalPerson.status !== LegalPersonStatusEnum.PROPOSAL) {
        return (React.createElement("div", null,
            formatMessage({ id: "ui-br-agency.modal.label.error" }),
            ":",
            " ",
            formatMessage({
                id: "ui-br-agency.legal-person.error.statusNotDraft",
            })));
    }
    if (!isSuperUser && currentUser) {
        if (!((_a = legalPerson.proposer) === null || _a === void 0 ? void 0 : _a.sourceId)) {
            return (React.createElement("div", null,
                formatMessage({ id: "ui-br-agency.modal.label.error" }),
                ":",
                " ",
                formatMessage({
                    id: "ui-br-agency.legal-person.error.proposerMismatch",
                })));
        }
        var userPublisherSourceId = (_b = currentUser.activeOrganization) === null || _b === void 0 ? void 0 : _b.sourceId;
        if (userPublisherSourceId !== legalPerson.proposer.sourceId) {
            return (React.createElement("div", null,
                formatMessage({ id: "ui-br-agency.modal.label.error" }),
                ":",
                " ",
                formatMessage({
                    id: "ui-br-agency.legal-person.error.proposerMismatch",
                })));
        }
    }
    return React.createElement(LegalPersonForm, { initialValues: legalPerson, isEdit: true });
};
export default LegalPersonEdit;
